import i18n from '@opsbase/lib-i18n';
import PlaceQueryChooser from '@opsbase/web-data-choosers/PlaceQueryChooser';
import Card from '@opsbase/web-layout/Card';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Vertical from '@opsbase/web-layout/Vertical';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useMemo } from 'react';
export function WhereSettingsSection(props) {
    const { definition, isEditable = false, onChange, isAsset, onSelectAll, isOpDefLocked } = props;
    const handleChangePlaces = useCallback(permitted => {
        onChange({ places: permitted });
    }, [onChange]);
    const handleChangeSelectedByTag = useCallback(placesSelectedByTag => {
        onChange({ placesSelectedByTag, placesSelectedByParent: false });
    }, [onChange]);
    const handleChangePlacesSelectedByParent = useCallback(placesSelectedByParent => {
        onChange({
            placesSelectedByParent,
            placesSelectedByTag: false,
        });
    }, [onChange]);
    const handleChangePlaceTags = useCallback(placeTags => onChange({ placeTags }), [onChange]);
    const content = useMemo(() => {
        var _a, _b;
        return (React.createElement(PlaceQueryChooser, { type: isAsset ? 'asset' : 'opdefinition', disabled: !isEditable || isOpDefLocked, places: (_a = definition.places) !== null && _a !== void 0 ? _a : [], onChangePlaces: handleChangePlaces, onChangePlaceTags: handleChangePlaceTags, onChangePlacesSelectedByParent: handleChangePlacesSelectedByParent, onChangePlacesSelectedByTag: handleChangeSelectedByTag, onSelectAll: onSelectAll, placesSelectedByTag: definition.placesSelectedByTag, placeTags: (_b = definition.placeTags) !== null && _b !== void 0 ? _b : [], placesSelectedByParent: definition.placesSelectedByParent }));
    }, [
        isAsset,
        isEditable,
        isOpDefLocked,
        definition.places,
        definition.placesSelectedByTag,
        definition.placeTags,
        definition.placesSelectedByParent,
        handleChangePlaces,
        handleChangePlaceTags,
        handleChangePlacesSelectedByParent,
        handleChangeSelectedByTag,
        onSelectAll,
    ]);
    if (isAsset)
        return content;
    return (React.createElement(Vertical, { gutter: true, padding: true },
        React.createElement(Horizontal, { gutter: true, justify: "flex-start", alignItems: "flex-bottom" },
            React.createElement(Text, { variant: "h1" }, i18n.t('where')),
            React.createElement(Text, { color: "grey" }, i18n.t('select-opdef-places'))),
        React.createElement(Card, { padding: true },
            React.createElement(Vertical, { paddingY: true, gutter: true }, content))));
}
export default WhereSettingsSection;
